import React from "react";
import { useDispatch, useSelector } from "react-redux";

export default function RequireData<T, U extends string>(
    dataSelector: (state: sage.state.IRedux) => T,
    fetchStatusSelector: (state: sage.state.IRedux) => U,
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    fetchAction: any
): [T, U] {
    const dispatch = useDispatch();
    const data = useSelector(dataSelector);
    const status = useSelector(fetchStatusSelector);

    React.useEffect(() => {
        if (status === "none" && (data === null || data === undefined)) {
            dispatch(fetchAction);
        }
    }, [data, status, dispatch, fetchAction]);

    return [data, status];
}
